export default "__VITE_ASSET__f066f767__"